import moment from "jalali-moment";

//Metrix

import { getUserData } from "./data.transformers";
import Cookies from "js-cookie";

const handleFundSlug = (dscode) => {
  switch (dscode) {
    case "12180":
      return "xjarx";
    case "10789":
      return "thdzl";
    case "11518":
      return "qykha";
    case "12196":
      return "avepr";
    case "11308":
      return "dmxac";
    case "12039":
      return "fhovc";
    case "11726":
      return "qhlxx";
    case "12196-1":
      return "bzfac";
    case "11808":
      return "rsose";

    default:
      return null;
  }
};

const handlePmaSlug = (id) => {
  switch (id) {
    case 1:
      return "dddos";
    case 2:
      return "nkkjl";
    case 3:
      return "nbdfj";
    case 4:
      return "adymt";
    case 9:
      return "kathy";
    case 10:
      return "vmlra";
    case 11:
      return "ehqdk";

    default:
      return null;
  }
};

export const MetrixEvents = (metrix, slug, array = []) => {
  const attributes = {};
  array?.length && array.map((item) => (attributes[item.key] = item.value));
  metrix?.sendEvent(slug, attributes);
};

export const handlePageMetrixEvents = async (
  metrix,
  path,
  dscode,
  portfoId
) => {
  const user = await getUserData();

  const attrs = [{ key: "user_id", value: user?.sub }];

  switch (path) {
    case "/home":
      return MetrixEvents(metrix, "kcwcp", attrs);
    case "/funds":
      return MetrixEvents(metrix, "dqmub", attrs);
    case `/funds/${dscode}`:
      return MetrixEvents(metrix, handleFundSlug(dscode), attrs);
    case "/assets":
      return MetrixEvents(metrix, "mysgm", attrs);
    case "/profile":
      return MetrixEvents(metrix, "vslpe", attrs);
    case "/pmas":
      return MetrixEvents(metrix, "tnzwe", attrs);
    case `/pmas/${portfoId}`:
      return MetrixEvents(metrix, handlePmaSlug(portfoId), attrs);
    case "/fund-orders":
      return MetrixEvents(metrix, "fhyzq", attrs);
    case "/fund-transactions":
      return MetrixEvents(metrix, "oltvf", attrs);
    case "/faq":
      return MetrixEvents(metrix, "oekhq", attrs);
    case "/prize":
      return MetrixEvents(metrix, "coycq", attrs);
    case "/referral":
      return MetrixEvents(metrix, "djqzr", attrs);
    case "/bank/promotion":
      return MetrixEvents(metrix, "hfmyl", attrs);
    case "/bank/operations/card-to-card":
      return MetrixEvents(metrix, "cvbav", attrs);
    case "/bank/operations/sheba":
      return MetrixEvents(metrix, "tfxbh", attrs);
    case "/fast-invest":
      return MetrixEvents(metrix, "irlow", attrs);
    case "/bank/transactions":
      return MetrixEvents(metrix, "fiamj", attrs);

    default:
      return null;
  }
};

export const handleClickMetrixEvents = async (metrix, type, attr = []) => {
  const user = await getUserData();

  const attrs = [{ key: "user_id", value: user?.sub }, ...attr];

  switch (type) {
    case "inquiry_fund_orders":
      return MetrixEvents(metrix, "zgpvw", attrs);
    case "history":
      return MetrixEvents(metrix, "lrnbi", attrs);
    case "asset-composition":
      return MetrixEvents(metrix, "jrsuo", attrs);
    case "account-activation":
      return MetrixEvents(metrix, "hflbm", attrs);
    case "onb-activation":
      return MetrixEvents(metrix, "ltqrs", attrs);
    case "fund-info":
      return MetrixEvents(metrix, "bhwsj", attrs);
    case "reinvest":
      return MetrixEvents(metrix, "xxiee", attrs);
    case "reinvest-submit":
      return MetrixEvents(metrix, "vlmau", attrs);
    case "payment":
      return MetrixEvents(metrix, "oiawh", attrs);
    case "payment-receipt":
      return MetrixEvents(metrix, "gjodh", attrs);
    case "sell-account":
      return MetrixEvents(metrix, "ihvoa", attrs);
    case "faq-category":
      return MetrixEvents(metrix, "yvfww", attrs);
    case "home-banner":
      return MetrixEvents(metrix, "kfjqu", attrs);
    case "counseling":
      return MetrixEvents(metrix, "vwucx", attrs);
    case "buy-fund":
      return MetrixEvents(metrix, "mbpvb", attrs);
    case "sell-fund":
      return MetrixEvents(metrix, "mqgoq", attrs);
    case "payment-method":
      return MetrixEvents(metrix, "kqotg", attrs);
    case "sell-submit":
      return MetrixEvents(metrix, "dgwol", attrs);
    case "support":
      return MetrixEvents(metrix, "qopqo", attrs);
    case "change-broker-setting":
      return MetrixEvents(metrix, "zzvzb", attrs);
    case "change-broker-submit":
      return MetrixEvents(metrix, "jcxdc", attrs);
    case "user-assets":
      return MetrixEvents(metrix, "ydbro", attrs);
    case "prize-onboarding":
      return MetrixEvents(metrix, "zfpuq", attrs);
    case "prize-referral":
      return MetrixEvents(metrix, "ebtfh", attrs);
    case "prize-first-order":
      return MetrixEvents(metrix, "greal", attrs);
    case "prize-order-upto50":
      return MetrixEvents(metrix, "qcezy", attrs);
    case "card":
      return MetrixEvents(metrix, "cmjrg", attrs);
    case "bank-confirm-information-confirmation":
      return MetrixEvents(metrix, "tlgmc", attrs);
    case "bank-select-card-color":
      return MetrixEvents(metrix, "tcxgr", attrs);
    case "bank-video-verification-submit":
      return MetrixEvents(metrix, "hauai", attrs);
    case "prize-referral-copy":
      return MetrixEvents(metrix, "kiewk", attrs);
    case "prize-referral-share-code":
      return MetrixEvents(metrix, "csyls", attrs);
    case "bank-home-asset-back":
      return MetrixEvents(metrix, "hbdqu", attrs);
    case "bank-home-c2c":
      return MetrixEvents(metrix, "hkeux", attrs);
    case "bank-home-money-transfer":
      return MetrixEvents(metrix, "zmqgm", attrs);
    case "bank-home-banner":
      return MetrixEvents(metrix, "zrfzg", attrs);
    case "bank-home-show-more":
      return MetrixEvents(metrix, "oxwjk", attrs);
    case "bank-limit-amount-modal":
      return MetrixEvents(metrix, "xgvcd", attrs);
    case "bank-limit-amout-modal-view-fund":
      return MetrixEvents(metrix, "erymf", attrs);
    case "bank-limit-amout-modal-fast-invest":
      return MetrixEvents(metrix, "hnffa", attrs);
    case "bank-limit-amount-fast-invest-payment":
      return MetrixEvents(metrix, "wtnst", attrs);

    default:
      return null;
  }
};

//Webengage

export const handleWebengageObjectId = (path, id) => {
  return path?.includes(id) ||
    (id &&
      (path?.includes("buy") ||
        path?.includes("sell") ||
        path?.includes("change-broker")))
    ? id
    : null;
};

export const WebengagePageEvent = (
  eventName,
  pageName,
  prevPage = "",
  objectId = ""
) => {
  return window?.webengage?.track(eventName, {
    "Page Name": pageName,
    From: prevPage || "",
    "Object ID": objectId || "",
    Date: new Date(),
  });
};

export const pageTitle = (page, id = null) => {
  switch (page) {
    case "/home":
      return "home";
    case "/assets":
      return "asset";
    case "/funds":
      return "fund";
    case `/funds/${id}`:
      return "fund-detail";
    case `/card`:
      return "bank";
    case "/bank/asset-back":
      return "asset-back";
    case "/change-broker":
      return "change-broker";
    case "/profile":
      return "profile";
    case "/referral":
      return "referral";
    case "/prize":
      return "prize";
    case "/fund-transactions":
    case `/fund-transactions/${id}`:
      return "fund-transactions";
    case "/fund-orders":
    case `/fund-orders/${id}`:
      return "fund-orders";
    case "/faq":
      return "faq";
    case "/fund/profit-sharing":
      return "profit-share";
    case "/chatbot":
      return "chatbot";
    case "/onboarding":
      return "signup";
    case "/buy":
      return "buy-fund";
    case "/sell":
      return "sell-fund";
    case "/":
      return "login";
    case "/bank/onboarding":
      return "bank-onboarding";
    case "/fast-invest":
      return "bank-fast-invest";
    case "/pma":
      return "pma";
    case `/pma/${id}`:
      return "pma-detail";
    case "/accounts":
      return "withdraw-fund";
    case "/payment":
      return "payment-fund";
    case "/payment/receipt":
      return "reciept-fund";
    default:
      return "";
  }
};

export const handlePageEventName = (pageName) => {
  switch (pageName) {
    case "home":
      return "PageVisit_Home";
    case "asset":
      return "PageVisit_Asset";
    case "fund":
      return "PageVisit_Fund";
    case "fund-detail":
      return "PageVisit_FundDetail";
    case "bank":
      return "PageVisit_Bank";
    case "asset-back":
      return "PageVisit_AssetBack";
    case "change-broker":
      return "PageVisit_ChangeBroker";
    case "profile":
      return "PageVisit_Profile";
    case "referral":
      return "PageVisit_Referral";
    case "prize":
      return "PageVisit_Prize";
    case "fund-transactions":
      return "PageVisit_FundTransactions";
    case "fund-orders":
      return "PageVisit_FundOrders";
    case "faq":
      return "PageVisit_Faq";
    case "profit-share":
      return "PageVisit_ProfitShare";
    case "chatbot":
      return "PageVisit_Chatbot";
    case "signup":
      return "PageVisit_Signup";
    case "buy-fund":
      return "PageVisit_BuyFund";
    case "sell-fund":
      return "PageVisit_SellFund";
    case "login":
      return "PageVisit_Login";
    case "bank-onboarding":
      return "PageVisit_BankOnboarding";
    case "bank-fast-invest":
      return "PageVisit_BankFastInvest";
    case "pma":
      return "PageVisit_Pma";
    case `pma-detail`:
      return "PageVisit_PmaDetail";
    case "withdraw-fund":
      return "PageVisit_WithdrawFund";
    case "payment-fund":
      return "PageVisit_PaymentFund";
    case "receipt-fund":
      return "PageVisit_ReceiptFund";
    default:
      return "";
  }
};

const handleCondition = (buttonName) => {
  const webengageEvents =
    Cookies.get("webengageEvents") &&
    JSON.parse(Cookies.get("webengageEvents"));

  return webengageEvents?.button_click?.includes(buttonName);
};

const handleButtonEventName = (buttonName) => {
  switch (buttonName) {
    //custom
    case "home-button-activation":
    case "button-account-activation":
    case "bank-button-start":
      return "Onboarding_Started";
    case "fund-button-reinvest-submit":
      return "Reinvest_ValueChanged";
    case "buy-fund-button-terms":
      return "Order_TermsVisited";
    case "buy-fund-button-submit":
    case "sell-fund-button-submit":
      return "Order_Initialized";
    case "buy-fund-button-payment":
    case "buy-fund-button-upload-receipt":
      return "Order_PaymentMethodSelected";
    case "buy-fund-button-submit-receipt":
      return "Order_ReceiptSubmitted";
    case "buy-fund-button-after-payment":
      return "Order_TransactionFinalized";
    case "buy-fund-button-confirm-otp":
    case "sell-fund-button-confirm-otp":
      return "Order_OTPSubmitted";
    case "sell-fund-button-destination":
      return "Order_DestinationSelected";
    case "bank-button-request":
      return "Onboarding_CardRequested";
    case "bank-button-verification":
      return "Onboarding_SerialnumberSubmited";
    case "bank-button-card-select":
      return "Onboarding_CardColorSelected";
    case "bank-button-video-verification":
      return "Onboarding_VideoRecordStarted";
    case "bank-button-video-review":
      return "Onboarding_VideoRecordSubmitted";
    case "bank-button-address":
      return "Onboarding_AddressSubmitted";
    case "bank-button-transfer-Initialized":
      return "Transfer_Initialized";
    case "bank-button-transfer-verified":
      return "Transfer_Verified";
    case "bank-button-transfer-otpverified":
      return "Transfer_OTPVerified";
    case "bank-button-transfer-finished":
      return "Transfer_Finished";
    case "signup-button-enter-national-code":
      return "Onboarding_NationalCodeSubmitted";
    case "signup-button-sejam-otp":
      return "Onboarding_OTPSubmitted";
    case "signup-button-set-password":
      return "Onboarding_PasswordSet";

    //general
    case "home-button-funds-slider":
      return "ClickButton_FundsSlider";
    case "home-button-funds-list":
      return "ClickButton_FundsList";
    case "home-button-pma-slider":
      return "ClickButton_PmaSlider";
    case "home-button-pma-list":
      return "ClickButton_PmaList";
    case "home-button-video":
      return "ClickButton_Video";
    case "home-button-chatbot":
      return "ClickButton_Chatbot";
    case "home-button-banner":
      return "ClickButton_Banner";
    case "home-button-start-investment":
      return "ClickButton_StartInvestment";
    case "home-button-asset-management":
      return "ClickButton_AssetManagement";
    case "home-button-eye":
      return "ClickButton_Eye";
    case "home-button-update":
      return "ClickButton_Update";
    case "home-button-tracking-order":
      return "ClickButton_TrackingOrder";
    case "home-button-orders":
      return "ClickButton_Orders";
    case "asset-button-all-orders":
      return "ClickButton_AllOrders";
    case "asset-button-pending-orders":
      return "ClickButton_PendingOrders";
    case "asset-button-funds-details":
      return "ClickButton_FundsDetails";
    case "asset-button-stocks-details":
      return "ClickButton_StocksDetails";
    case "asset-button-pmas-details":
      return "ClickButton_PmasDetails";
    case "asset-button-change-broker":
      return "ClickButton_ChangeBroker";
    case "invest-button-video":
      return "ClickButton_Video";
    case "invest-button-eye":
      return "ClickButton_Eye";
    case "invest-button-funds-details":
      return "ClickButton_FundsDetails";
    case "profile-button-account":
      return "ClickButton_Account";
    case "profile-button-banner":
      return "ClickButton_Banner";
    case "profile-button-prize":
      return "ClickButton_Prize";
    case "profile-button-referral":
      return "ClickButton_Referral";
    case "profile-button-orders":
      return "ClickButton_Orders";
    case "profile-button-transactions":
      return "ClickButton_Transactions";
    case "profile-button-update":
      return "ClickButton_Update";
    case "profile-button-faq":
      return "ClickButton_Faq";
    case "profile-button-support":
      return "ClickButton_Support";
    case "profile-button-regulation":
      return "ClickButton_Regulation";
    case "profile-button-logout":
      return "ClickButton_Logout";
    case "fund-button-video":
      return "ClickButton_Video";
    case "fund-button-orders":
      return "ClickButton_Orders";
    case "fund-button-moreinfo":
      return "ClickButton_Moreinfo";
    case "fund-button-counselling":
      return "ClickButton_Counselling";
    case "fund-button-share-profit":
      return "ClickButton_ShareProfit";
    case "fund-button-buy":
      return "ClickButton_Buy";
    case "fund-button-sell":
      return "ClickButton_Sell";
    case "fund-button-change-broker":
      return "ClickButton_ChangeBroker";
    case "fund-button-fund-onboarding-submit":
      return "ClickButton_FundOnboardingSubmit";
    case "fund-button-fund-profit-config":
      return "ClickButton_FundProfitConfig";
    case "changebroker-button-request":
      return "ClickButton_Request";
    case "faq-button-support":
      return "ClickButton_Support";
    case "prize-button-banner":
      return "ClickButton_Banner";
    //no
    case "prize-button-gift":
      return "ClickButton_Gift";
    case "prize-button-mission":
      return "ClickButton_Mission";
    case "referral-button-banner":
      return "ClickButton_Banner";
    case "referral-button-prize":
      return "ClickButton_Prize";
    case "referral-button-share-code":
      return "ClickButton_ShareCode";
    case "referral-button-copy-code":
      return "ClickButton_CopyCode";
    //no
    case "pma-button-video":
      return "ClickButton_Video";
    case "pma-button-details":
      return "ClickButton_Details";
    //no
    case "pma-button-counselling":
      return "ClickButton_Counselling";
    //no
    case "pma-button-more-details":
      return "ClickButton_MoreDetails";
    case "orders-button-details":
      return "ClickButton_Details";
    case "orders-button-transactions":
      return "ClickButton_Transactions";
    case "transactions-button-details":
      return "ClickButton_Details";
    case "bank-button-video":
      return "ClickButton_Video";
    case "bank-button-continue":
      return "ClickButton_Continue";
    case "bank-button-edit":
      return "ClickButton_Edit";
    case "bank-button-tracking":
      return "ClickButton_Tracking";
    case "bank-button-delivered":
      return "ClickButton_Delivered";
    case "bank-button-c2c":
      return "ClickButton_C2C";
    case "bank-button-money-transfer":
      return "ClickButton_MoneyTransfer";
    case "bank-button-banner":
      return "ClickButton_Banner";
    case "bank-button-all-transactions":
      return "ClickButton_AllTransactions";
    case "bank-button-limit-amount-modal-view-fund":
      return "ClickButton_LimitAmountModalViewFund";
    case "bank-button-limit-amount-modal-fast-invest":
      return "ClickButton_LimitAmountModal-FastInvest";
    case "bank-button-limit-amount-fast-invest-payment":
      return "ClickButton_LimitAmountFastInvestPayment";
    case "bank-button-asset-back":
      return "ClickButton_AssetBack";
    case "bank-button-deposit":
      return "ClickButton_Deposit";
    case "bank-button-settings":
      return "ClickButton_Settings";
    case "assets-back-button-all":
      return "ClickButton_All";
    case "signup-button-confirm":
      return "ClickButton_Confirm";
    case "login-button-pre-login":
      return "ClickButton_PreLogin";
    default:
      return "";
  }
};

export const WebengageGeneralButtonEvent = (
  buttonName,
  pageName = null,
  buttonType,
  attributes = {}
) => {
  return (
    handleCondition(buttonName) &&
    window?.webengage?.track(handleButtonEventName(buttonName), {
      "Button Name": buttonName,
      "Page Name": pageTitle(
        pageName || window.location.pathname,
        attributes["Object ID"]
      ),
      "Button Type": buttonType,
      Date: new Date(),
      ...attributes,
    })
  );
};
